module.exports = __webpack_public_path__ + "static/media/wellness.f6f4c132.svg";